import { axiosInstance } from '../../config/axiosConfig';
import { AxiosError, AxiosResponse } from 'axios';
import { IRecursiveQuestionResponse, IResultsResponse } from '../types/risklocator.type';
import { endPointUrls } from '../constants/endPoints';

const getRecursiveQuestions = (
    questionNodeId?: number,
    answerCode?: string,
    riskType?: string,
    answerGroupId?: number,
): Promise<IRecursiveQuestionResponse> => {
    return axiosInstance
        .get(endPointUrls.getRecursiveQuestion, { params: { questionNodeId, answerCode, riskType, answerGroupId } })
        .then((res: AxiosResponse<IRecursiveQuestionResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getResultsForRiskLocator = (
    propertyName: string,
    propertyValue: Record<string, string>,
): Promise<IResultsResponse> => {
    return axiosInstance
        .post(endPointUrls.postRiskLocation, { [propertyName]: propertyValue })
        .then((res: AxiosResponse<IResultsResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const risklocatorServices = {
    getRecursiveQuestions,
    getResultsForRiskLocator,
};

export default risklocatorServices;
